<template>
  <el-dialog title="Edit Event" width="70%" top="2em" 
    :fullscreen="$mq === 'xs'"
    :visible.sync="dialogVisible">
    <el-form v-if="event">
      <el-form-item label="Name">
        <el-input v-model="event.name" size="small"></el-input>
      </el-form-item>
      <el-form-item label="Date">
        <el-date-picker v-model="event.date" value-format="yyyy-MM-dd" size="small" type="date" />
      </el-form-item>
      <el-form-item label="Term">
        <el-select v-model="event.term" value-key="term" size="small" placeholder="Select Term">
          <el-option v-for="term in terms" :key="term.term" :label="term.name" :value="term" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">Save</el-button>
        <el-button @click="close">Cancel</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<style scoped>
.mg {
  max-width: 12em;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import {mapFields} from "vuex-map-fields";
export default {
    props: {value: {required: true}},
    data() {
        return {event: this.value, dialogVisible: false};
    },
    watch: {
        value(val) {
            this.event = val;
        }
    },
    computed: {...mapFields(["terms"])},
    methods: {
        save() {
            if (this.event.o_id) {
                this.axios
                    .put(
                        "/api/v1/events/" + this.event.o_id,
                        {
                            name: this.event.name,
                            date: this.event.date,
                            term: this.event.term.term,
                            event_type: this.event.event_type.o_id
                        },
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then((response) => {
                        this.$emit("save", response.data);
                        this.close();
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.message,
                            type: "error"
                        });
                    });
            } else {
                this.axios
                    .post(
                        "/api/v1/events",
                        {
                            name: this.event.name,
                            date: this.event.date,
                            term: this.event.term.term,
                            event_type: this.event.event_type
                        },
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then((response) => {
                        this.$emit("save", response.data);
                        this.close();
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message({
                            showClose: true,
                            message: err.response.data.message,
                            type: "error"
                        });
                    });
            }
        },
        close() {
            this.dialogVisible = false;
            this.$emit("close");
        },
        open() {
            this.event = this.value;
            this.dialogVisible = true;
        }
    }
};
</script>
